import $Form from '../../common/forms';

export default class PaymentMethod {
  constructor(option, form, paymentPage) {
    this.option = option;
    this.form = form;
    this.paymentPage = paymentPage;
  }

  showForm() {
    this.form.show();
  }

  hideForm() {
    this.form.hide();
  }

  showOption() {
    this.option.parent().removeClass('hidden');
  }

  showMe() {
    this.paymentPage.showOnly(this);
  }

  bindFormMethods(paymentPage) {
    this.paymentPage = paymentPage;

    this.option.on('click', this.showMe.bind(this));
    this.form.on('submit', this.onSubmit.bind(this));
  }

  disable() {
    this.option.prop('disabled', true);
  }

  enable() {
    this.option.prop('disabled', false);
  }

  async isAvailable() {
    return false;
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    $Form.postAjax(this.form, this.form.find('input[type=submit]'));
  }
}
